import { makeStyles } from '@material-ui/core'
import helpers from 'helpers'

const styles = makeStyles((theme) => ({
  sectionPaper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(3),
  },
  attachmentItems: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 215,
  },
  attachmentButton: {
    padding: theme.spacing(2),
  },
  inputFile: {
    display: 'none',
  },
  whiteInput: {
    backgroundColor: theme.palette.background.paper,
  },
  outlinedWarningButton: {
    color: theme.palette.warning.main,
    borderColor: theme.palette.warning.main,
    '&:hover': {
      borderColor: theme.palette.warning.dark,
    },
  },
  containerWarningButton: {
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
  evidenceDate: {
    display: 'flex',
    alignContent: 'center',
    gridGap: theme.spacing(1),
    backgroundColor: helpers.palette.hexToRgba(
      theme.palette.greenSnowFlurry,
      0.2,
    ),
    color: theme.palette.partnerGreen.dark,
    borderRadius: 4,
    border: `1px solid ${theme.palette.greenPantone}`,
    padding: theme.spacing(2),
  },
}))

export default styles
